import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import { withNamespaces } from 'react-i18next'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import i18n from 'Pods/Shared/I18n' // Needed for SSR

import ProductPriceBuyActions from './ProductPriceBuyActions'
import ProductLicense from './ProductLicense'
import ProductActionButton from '../../ProductActionButton/ProductActionButton'

function ProductPriceStandard({
  storeCreditsLeft,
  creditsCanBeApplied,
  finalPrice,
  hidePriceOffer = false,
  acceptsPriceOffer,
  id,
  page,
  license,
  title,
  cartItems,
  isDisabled = false,
  isPurchased,
  isSignedIn,
  licenseText,
  t,
}) {
  return (
    <div
      itemProp="offers"
      itemScope=""
      itemType="http://schema.org/Offer"
      className="container-fixed"
    >
      <meta itemProp="priceCurrency" content="USD" />

      <div className="col-12">
        <div className="sticky-container">
          <div className="sticky-price-bar__title">
            {title}
          </div>
          <div className="sticky-price-bar__price">
            <div
              className={`product-pricing__price-row ${storeCreditsLeft === 0 && creditsCanBeApplied ? 'price-credits' : ''}`}
            >
              <div className="product-pricing__price" itemProp="price">
                <Tooltip
                  id="vatNotice"
                  content={t('vatNotice')}
                  className={`u-block${isDisabled ? ' is-disabled' : ''}`}
                >
                  {numeral(finalPrice).format('$0.00')}
                </Tooltip>

                {storeCreditsLeft === 0 && creditsCanBeApplied && !isPurchased && (
                  <div
                    className="product-pricing__no-credits"
                    onClick={() => App.events.publish('top:menu:credits:open')}
                  >
                    Save with <span className="no-credits__highlight">CGTrader Points</span>
                  </div>
                )}
              </div>

              {!hidePriceOffer && acceptsPriceOffer && !isPurchased && (
                <Tooltip
                  id="productPriceOfferButton"
                  className="product-pricing__make-offer"
                  tooltipClassName="u-text-center"
                  content="Send your price offer to the author if you want to buy it at lower price."
                >
                  <ProductActionButton
                    classes="btn btn-outline-default"
                    title="Offer price"
                    action="openOfferPriceModal"
                    iconType={['far', 'handshake']}
                    isSignedIn={isSignedIn}
                    itemPrice={finalPrice}
                    itemId={id}
                  />
                </Tooltip>
              )}
            </div>

            <ProductLicense {...license} licenseText={licenseText} />
            {isPurchased && (
              <span className="product-pricing__purchased-note">
                <Icon type={['fal', 'bell']} />
                You have already purchased this item.
              </span>
            )}

            <ProductPriceBuyActions
              id={id}
              price={finalPrice}
              page={page}
              cartItems={cartItems}
              isPurchased={isPurchased}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ProductPriceStandard.propTypes = {
  storeCreditsLeft: PropTypes.number.isRequired,
  creditsCanBeApplied: PropTypes.bool.isRequired,
  finalPrice: PropTypes.number.isRequired,
  hidePriceOffer: PropTypes.bool,
  acceptsPriceOffer: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  license: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  cartItems: PropTypes.array,
  isDisabled: PropTypes.bool,
}

export default withNamespaces('product')(ProductPriceStandard)
